module.exports = __webpack_public_path__ + "static/media/undraw_Forgot_password_re_hxwm.4a1cb2ea.png";